import { useSyncExternalStore } from "react";
import { whenIdle } from "@wags/tanstack-start/browser";
import { DOG_DESKTOP_QUERY } from "./dog-desktop-layout";

let idle = false;
const listeners = new Set<() => void>();
let scheduled = false;

function subscribe(listener: () => void) {
    listeners.add(listener);
    if (!scheduled && !idle) {
        scheduled = true;
        whenIdle(() => {
            idle = true;
            for (const item of listeners) item();
        });
    }
    return () => {
        listeners["delete"](listener);
    };
}

export function useAfterIdle(): boolean {
    return useSyncExternalStore(
        subscribe,
        () => idle,
        () => false,
    );
}

function subscribeDesktop(listener: () => void) {
    const query = window.matchMedia(DOG_DESKTOP_QUERY);
    query.addEventListener("change", listener);
    return () => query.removeEventListener("change", listener);
}

export function useDesktopLayout(): boolean {
    return useSyncExternalStore(
        subscribeDesktop,
        () => window.matchMedia(DOG_DESKTOP_QUERY).matches,
        () => false,
    );
}

export function idleProviderIds(
    idleNow: boolean,
    organizationId: string | null | undefined,
) {
    if (!idleNow || !organizationId) return [];
    return [organizationId];
}

export function idleOrganizationId(
    idleNow: boolean,
    organizationId: string | null | undefined,
) {
    if (!idleNow || !organizationId) return "";
    return organizationId;
}

export function idleEnabled(idleNow: boolean, enabled: boolean) {
    return idleNow && enabled;
}
